import auth from '../../middleware/auth';

const props = (route) => {
	return {
		templateId: parseInt(route.params.id)
	};
};

export default {
	path: ':id(\\d+)',
	name: 'mag-template-view',
	props: props,
	component: () => import('../../../views/MonitorActionGroupTemplateShow'),
	meta: {
		middleware: [
			auth
		]
	}
};
